import React, { useState, useEffect } from 'react';

function PublicBooking() {
    const [slots, setSlots] = useState([]);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [success, setSuccess] = useState(null);
    const [error, setError] = useState(null);

    const [formData, setFormData] = useState({
        parent_name: '',
        email: '',
        phone: '',
        child_name: '',
        child_age: '',
        message: ''
    });

    useEffect(() => {
        fetchSlots();
    }, []);

    const fetchSlots = () => {
        setLoading(true);
        fetch('/api/public/available-slots')
            .then(res => res.json())
            .then(data => {
                setSlots(data.data || []);
                setLoading(false);
            })
            .catch(err => {
                console.error('Fehler beim Laden:', err);
                setLoading(false);
            });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitting(true);
        setError(null);

        fetch('/api/public/book-slot', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                slot_id: selectedSlot.id,
                ...formData,
                child_age: formData.child_age ? parseInt(formData.child_age) : null
            })
        })
            .then(res => res.json())
            .then(data => {
                setSubmitting(false);
                if (data.message === 'success') {
                    setSuccess(data.data);
                    setSelectedSlot(null);
                    setFormData({
                        parent_name: '',
                        email: '',
                        phone: '',
                        child_name: '',
                        child_age: '',
                        message: ''
                    });
                    fetchSlots();
                } else {
                    setError(data.error || 'Ein Fehler ist aufgetreten');
                }
            })
            .catch(err => {
                setSubmitting(false);
                setError('Verbindungsfehler. Bitte versuche es erneut.');
            });
    };

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleDateString('de-DE', {
            weekday: 'long',
            day: '2-digit',
            month: 'long',
            year: 'numeric'
        });
    };

    const formatTime = (timeStr, duration) => {
        const [hours, minutes] = timeStr.split(':').map(Number);
        const endMinutes = hours * 60 + minutes + duration;
        const endHours = Math.floor(endMinutes / 60);
        const endMins = endMinutes % 60;
        return `${timeStr} - ${String(endHours).padStart(2, '0')}:${String(endMins).padStart(2, '0')} Uhr`;
    };

    // Group slots by month
    const groupedSlots = slots.reduce((groups, slot) => {
        const date = new Date(slot.date);
        const monthKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
        const monthName = date.toLocaleDateString('de-DE', { month: 'long', year: 'numeric' });

        if (!groups[monthKey]) {
            groups[monthKey] = { name: monthName, slots: [] };
        }
        groups[monthKey].slots.push(slot);
        return groups;
    }, {});

    // Success view
    if (success) {
        return (
            <div className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-md-8 col-lg-6">
                        <div className="card border-success">
                            <div className="card-body text-center py-5">
                                <div className="mb-4">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" className="text-success" viewBox="0 0 16 16">
                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                                    </svg>
                                </div>
                                <h2 className="text-success mb-3">Buchung erfolgreich!</h2>
                                <p className="lead mb-4">
                                    Vielen Dank, {success.parent_name}!<br />
                                    Dein Termin wurde bestaetigt.
                                </p>
                                <div className="bg-light rounded p-3 mb-4">
                                    <strong>{formatDate(success.date)}</strong><br />
                                    {success.time} Uhr<br />
                                    <small className="text-muted">{success.title}</small>
                                </div>
                                <p className="text-muted mb-4">
                                    Vielen Dank fuer deine Anmeldung! Wir melden uns zeitnah bei dir.
                                </p>
                                <button
                                    className="btn btn-outline-primary"
                                    onClick={() => setSuccess(null)}
                                >
                                    Weiteren Termin buchen
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container py-4">
            <div className="row justify-content-center">
                <div className="col-lg-10">
                    <div className="text-center mb-4">
                        <h1 className="h2">Kennenlernen</h1>
                        <p className="lead text-muted">
                            Lerne unsere Einrichtung kennen und nimm an einem kostenlosen Schnupper-Workshop teil!
                        </p>
                    </div>

                    {loading ? (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Laden...</span>
                            </div>
                        </div>
                    ) : selectedSlot ? (
                        /* Booking Form */
                        <div className="row justify-content-center">
                            <div className="col-md-8">
                                <div className="card">
                                    <div className="card-header bg-primary text-white">
                                        <h5 className="mb-0">Termin buchen</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="alert alert-light border mb-4">
                                            <strong>{formatDate(selectedSlot.date)}</strong><br />
                                            {formatTime(selectedSlot.time, selectedSlot.duration)}<br />
                                            <small className="text-muted">{selectedSlot.title}</small>
                                        </div>

                                        {error && (
                                            <div className="alert alert-danger">{error}</div>
                                        )}

                                        <form onSubmit={handleSubmit}>
                                            <div className="mb-3">
                                                <label className="form-label">Dein Name *</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={formData.parent_name}
                                                    onChange={e => setFormData({ ...formData, parent_name: e.target.value })}
                                                    required
                                                    placeholder="Vor- und Nachname"
                                                />
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label">E-Mail *</label>
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        value={formData.email}
                                                        onChange={e => setFormData({ ...formData, email: e.target.value })}
                                                        required
                                                        placeholder="deine@email.de"
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label">Telefon</label>
                                                    <input
                                                        type="tel"
                                                        className="form-control"
                                                        value={formData.phone}
                                                        onChange={e => setFormData({ ...formData, phone: e.target.value })}
                                                        placeholder="Optional"
                                                    />
                                                </div>
                                            </div>

                                            <hr className="my-4" />
                                            <h6 className="mb-3">Kind (optional)</h6>

                                            <div className="row">
                                                <div className="col-md-8 mb-3">
                                                    <label className="form-label">Name des Kindes</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={formData.child_name}
                                                        onChange={e => setFormData({ ...formData, child_name: e.target.value })}
                                                        placeholder="Vorname"
                                                    />
                                                </div>
                                                <div className="col-md-4 mb-3">
                                                    <label className="form-label">Alter</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={formData.child_age}
                                                        onChange={e => setFormData({ ...formData, child_age: e.target.value })}
                                                        min="4"
                                                        max="18"
                                                        placeholder="Jahre"
                                                    />
                                                </div>
                                            </div>

                                            <div className="mb-4">
                                                <label className="form-label">Nachricht / Fragen</label>
                                                <textarea
                                                    className="form-control"
                                                    rows="3"
                                                    value={formData.message}
                                                    onChange={e => setFormData({ ...formData, message: e.target.value })}
                                                    placeholder="Gibt es etwas, das wir wissen sollten?"
                                                />
                                            </div>

                                            <div className="d-flex gap-2">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary btn-lg flex-grow-1"
                                                    disabled={submitting}
                                                >
                                                    {submitting ? (
                                                        <>
                                                            <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                            Wird gebucht...
                                                        </>
                                                    ) : (
                                                        'Termin verbindlich buchen'
                                                    )}
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary btn-lg"
                                                    onClick={() => setSelectedSlot(null)}
                                                    disabled={submitting}
                                                >
                                                    Zurueck
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : slots.length === 0 ? (
                        /* No slots available */
                        <div className="text-center py-5">
                            <div className="alert alert-info">
                                <h5>Aktuell keine Termine verfuegbar</h5>
                                <p className="mb-0">
                                    Schau bald wieder vorbei oder kontaktiere uns direkt.
                                </p>
                            </div>
                        </div>
                    ) : (
                        /* Slot selection */
                        <div className="row">
                            {Object.entries(groupedSlots).map(([monthKey, group]) => (
                                <div key={monthKey} className="col-12 mb-4">
                                    <h5 className="border-bottom pb-2 mb-3">{group.name}</h5>
                                    <div className="row">
                                        {group.slots.map(slot => (
                                            <div key={slot.id} className="col-md-6 col-lg-4 mb-3">
                                                <div
                                                    className="card h-100 cursor-pointer border-2"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => setSelectedSlot(slot)}
                                                >
                                                    <div className="card-body">
                                                        <div className="d-flex justify-content-between align-items-start">
                                                            <div>
                                                                <h6 className="card-title mb-1">
                                                                    {new Date(slot.date).toLocaleDateString('de-DE', {
                                                                        weekday: 'short',
                                                                        day: '2-digit',
                                                                        month: '2-digit'
                                                                    })}
                                                                </h6>
                                                                <p className="card-text text-primary fw-bold mb-2">
                                                                    {formatTime(slot.time, slot.duration)}
                                                                </p>
                                                            </div>
                                                            <span className="badge bg-success">Verfuegbar</span>
                                                        </div>
                                                        <p className="card-text small text-muted mb-0">
                                                            {slot.title}
                                                        </p>
                                                    </div>
                                                    <div className="card-footer bg-transparent border-0">
                                                        <button className="btn btn-outline-primary btn-sm w-100">
                                                            Auswaehlen
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default PublicBooking;
